module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row empty-state js-pipelines-error-state"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "svg-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pipelinesErrorStateSVG)
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('h4', [_vm._v("The API failed to fetch the pipelines.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dea8a94"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/error_state.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2dea8a94"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/error_state.vue
// module chunks = commit_pipelines pipelines